<template>
  <div class="modernBox u-mg-t-3" v-if="items.length">
    <p class="modernBox__title">待ち時間ゼロ！読む占い</p>
    <div class="modernBox__header">
      <span class="wordbreak">恋愛や仕事など、毎日の生活でちょっと気になることをテーマにした占いをリーズナブルにお楽しみいただけます。</span>
      <span class="u-mg-t-2 wordbreak">※こちらの商品はテキスト形式でお届けします。</span>
    </div>
    <div class="modernBox__contents u-width-10">
      <div class="listGroup u-mg-0"
        data-color="secondary"
        data-size="lg">
        <div class="listGroup__body">
          <ul>
            <li class="listGroup__item text" data-arrow="false" v-for="(item, index) of items" :key="item.items_id">
              <a class="media g-summaryText"
                :href="`/contents/${getId(item.items_id)}?top_txt=${index + 1}`"
                :data-items-id="item.items_id"
              >
                <div class="media__image" data-size="xm" data-clip-path-support="true">
                  <uranai-img data-clip-path-support="true" data-size="xm" size="xm" :src="item.pack_image"></uranai-img>
                </div>
                <div class="media__text">
                  <div class="media__content">
                    <div>
                      <h4 class="media__title">{{ item.item_name }}</h4>
                    </div>
                    <div class="rowcontent">
                      <p class="counselorname">占い師：{{ item.counselor_name }}</p>
                      <div class="media__description">
                        <div class="media__description_leftbox">
                          <div class="tagarea">
                            <span class="badge">{{item.service_type_str}}</span>
                            <span :class="['badge', `u-tag-${item.category_tag_id}`]">{{ item.category_tag_name }}</span>
                          </div>
                        </div>
                        <div class="pricearea" data-color="white" v-if="item.price && item.price === 0">
                          <span class="pricetag">無料</span>
                        </div>
                        <div class="pricearea notfree" data-color="white" v-if="item.price && item.price > 0">
                          <span class="pricetag">¥{{ item.price }}</span>
                          <span class="tax">(税込)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div class="btn_showmore" v-on:click="getMoreItems()">
          <p class="inner" v-if="!is_loading"><span class="inner_text">もっと見る</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'read-list',
  data() {
    return {
      items: [],
      is_loading: false
    };
  },
  mounted() {
    axios
      .post('/api/items/read/list', { number: 3 })
      .then(content => content.data)
      .then(contents => (this.items = contents));
  },
  methods: {
    getMoreItems() {
      if (this.is_loading) return;
      this.is_loading = true;
      gtag('event', 'click', {
        event_category: 'general',
        event_label: 'top_moreTxt'
      });
      axios
        .post('/api/items/read/list', { number: -1 })
        .then(content => content.data)
        .then(contents => (this.items = contents));
    },
    getId(id) {
      return ('000000' + id).substr(-6);
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ReadList.vue